<template>
  <div class="event-block block" style="margin-top: 0;" :class="[typeCourse, { large }]">
    <div class="head">
      <div class="time-dur-event">
        <div class="time">
          <span>13:00 - 17:00</span>
        </div>
        <div class="dur">
          <span v-text="$t('events.b2b-group.time')"/>
        </div>
      </div>
      <div
          class="badge"
          :style="`background-color: ${color.bg}; color: ${color.text}`"
          v-if="typeCourseName"
          v-text="typeCourseName"
      />
    </div>

    <div class="title" v-text="'B2B' + ' ' + $t('events.b2b-group.title')"/>
    <div class="b2b-list">
      <div v-for="(item, i) in event.list" :key="i">
        <div
            v-for="(event, j) in item"
             :key="j"
            class="b2b-list-item"
            :class="{'passed' : momentIsBefore(event.time_finish)}"
        >
          <RightNow v-if="isOnline(event)" />
          <div class="text-elips"  v-tippy="{ placement : 'top-start',  arrow: true}" :content="$localized(event.localized_name, 'B2B meeting')">{{$localized(event.localized_name, 'B2B meeting')}}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="event-link" :class="{disabled: !currentOnline}" @click="watchZoom">
        <button class="primary" :class="{disabled: currentOnline && !currentOnline.zoom_link}">
          <ArrowRight class="event-block__join-icon"/>
        </button>
        <span>{{ $t('joinEvent') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/user/Avatar'
import TimeDurEvent from '@/components/events/TimeDurEvent'
import Rating from '@/components/events/Rating'
import {mapState} from 'vuex'
import _inRange from 'lodash/_baseInRange'
import isActualEvent from '../../mixins/isActualEvent'
import AttachmentCount from '@/components/events/AttachmentCount'
import ArrowRight from "@/components/icons/ArrowRight";
import Play from "@/components/icons/Play";
import RightNow from "@/components/RightNow";
import moment from "moment";

export default {
  name: 'EventB2B',
  components: {RightNow, Play, ArrowRight, AttachmentCount, Rating, TimeDurEvent, Avatar},
  mixins: [isActualEvent],
  props: {
    event: Object,
    extreme: Boolean,
    large: Boolean,
  },
  data() {
    return {
      currentOnline: null,
    }
  },
  computed: {
    special() {
      return this.event.course?.id === 2
    },
    needLink() {
      return this.event.type?.id !== 1
    },
    color() {
      switch ('qa') {
        case 'presentation':
          return {
            bg: 'rgba(222, 135, 3, 0.1);',
            text: '#DE8703',
          }
        case 'lecture':
          return {
            bg: 'rgba(0, 56, 130, 0.1);',
            text: '#003882',
          }
        case 'discussion':
          return {
            bg: 'rgba(195, 67, 67, 0.1);',
            text: '#C34343',
          }
        case 'qa':
          return {
            bg: 'rgba(0, 166, 227, 0.1);',
            text: '#00A6E3',
          }
        case 'workshop':
          return {
            bg: 'rgba(40, 173, 132, 0.1);',
            text: '#28AD84',
          }
      }

      return {}
    },
    typeCourseName() {
      return 'B2B'
    },
    typeCourse() {
      return this.special ? 'special' : 'general'
    },
  },
  methods: {
    momentIsBefore(time) {
      return moment(time).isBefore()
    },
    isOnline(event) {
      const {time_start, time_finish} = event

      if(_inRange(moment(), time_start, time_finish)) {
        this.currentOnline = event
      }

      return _inRange(moment(), time_start, time_finish)
    },
    watchZoom() {
      this.$emit('watch-zoom', this.currentOnline)
    },
  },
}
</script>

<style lang="scss">
.text-elips {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.b2b-list {
  margin-bottom: 25px;
  &-item {
    margin-bottom: 8px;
    color: #474747;
    font-size: 15px;
    &.passed {
      color: #CCD7E6;
    }
  }
}

.event-block {
  position: relative;
  z-index: 2;
  padding: 23px 20px 30px 21px;
  flex-shrink: 0;
  margin: 20px 0;

  @include mobile {
    padding-bottom: 25px;
  }

  &:first-child {
    margin-top: 0 !important;
  }

  &:hover {
    z-index: 3;
  }

  &.large {
    padding: 32px 43px 32px 32px;
    margin: 18px 0;

    .head {
      margin-bottom: 14px;
    }

    .hosts {
      margin-bottom: 29px;
    }

    .footer {
      align-items: flex-end;

      .footer-info {
        margin-bottom: 2px;
      }
    }
  }

  &__join-icon {
    margin-right: 0;
  }

  .primary {
    padding: 10px;
  }

  .head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 23px;

    & > *:first-child:last-child {
      justify-self: flex-end;
      margin-left: auto;
    }
  }

  .title {
    font-family: 'Source Serif Pro', serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 15px;
  }

  .hosts {
    margin-bottom: 25px;

    @include mobile {
      margin-bottom: 33px;
    }

    .user {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      font-weight: 400;
      font-size: 15px;
      line-height: 125%;
      color: $text;

      .avatar {
        margin-right: 15px;
      }

      &.add {
        margin-top: 15px;

        .name {
          font-weight: normal;
          color: $text;
          line-height: 1;
          text-decoration: underline;
          text-decoration-style: dashed;
          text-decoration-color: $dark;
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mobile {
      display: block;
    }

    .event-link {
      display: flex;
      align-items: center;
      cursor: pointer;
      appearance: none;
      text-decoration: none !important;

      @include mobile {
        margin-bottom: 20px;
      }
      svg {
        width: 8px;
        height: 8px;
      }

      button {
        width: 30px;
        height: 30px;
        padding: 0 !important;
        flex: none;
      }

      span {
        margin-left: 10px;
        font-weight: 600;
        font-size: 12px;
        color: $primary;
      }
      &.disabled {
        pointer-events: none;
        button {
          background: #CCD7E64D;
          svg {
            color: $dark;
          }
        }
        span {
          color: $dark;
        }
      }
    }

    .footer-info {
      display: flex;
      align-items: center;
    }
  }

  .badge {
    text-transform: capitalize;
  }

  .online-block {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    overflow: hidden;
    border-radius: 20px;
    height: 40px;
    pointer-events: none;

    &::before {
      content: '';
      display: block;
      width: 50%;
      height: 2px;
      background: $primary;
    }
  }

  &.general {
    .online-status-dote.online {
      background: $primary;
    }
  }

  &.special {
    .online-status-dote.online {
      background: $primary;
    }
  }

  &.vertical {
    margin: 0 4px;
  }

  @include PC {
    &.vertical {
      display: flex;
      flex-direction: column;
      width: 212px;
      height: 482px;
      padding: 16px 20px;
      padding-top: 100px;

      .title {
        min-height: 57px;
        margin-bottom: 42px;
      }

      .head {
        position: absolute;
        top: 16px;
        right: 20px;
        left: 20px;
        flex-direction: column;

        .time-dur-event {
          align-self: flex-end;
          margin-bottom: 10px;
        }

        .badge {
          order: 2;
        }
      }

      .hosts {
        height: 100%;
        flex-shrink: 2;
      }
    }
  }
}
</style>
